// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"0e34fdc9","325":"cc46389c"}[chunkId] + ".chunk.css";
};